export default class Highlighter {
    private wait: boolean = false;
    private highlighted!: string;
    private rule?: HTMLStyleElement;

    public onmousemove(e: MouseEvent) {
        if (!this.wait) {
            this.wait = true;
            setTimeout(() => this.wait = false, 20);
            let el = document.elementFromPoint(e.clientX, e.clientY);

            if (el) {
                if (el.className.includes('highlightable')) {
                    if (this.highlighted !== el.className.split(' ')[1]) {
                        this.lowlight();
                        this.highlighted = el.className.split(' ')[1];
                        this.highlight();
                    }
                } else {
                    el = el.parentElement;
                    if (el && el.className.includes('highlightable')) {
                        if (this.highlighted !== el.className.split(' ')[1]) {
                            this.lowlight();
                            this.highlighted = el.className.split(' ')[1];
                            this.highlight();
                        }
                    } else {
                        this.lowlight();
                    }
                }
            }
        }
    }

    private highlight() {
        this.rule = document.createElement('style');
        this.rule.innerHTML =
            `.highlightable.${this.highlighted} .name,` +
            `.highlightable.${this.highlighted} .value {background-color: #E4EAF2 !important;}`;
        document.body.appendChild(this.rule);
    }

    private lowlight() {
        if (this.rule) {
            document.body.removeChild(this.rule);
            this.rule = undefined;
            this.highlighted = '';
        }
    }
}
